(function(){
  /* Collegamento pulsanti di acquisto alla configurazione */
  var cfg={},links={};
  var nomi={partenza:'Partenza',lavoro:'Lavoro',completo:'Trasferimento Completo'};
  Array.prototype.forEach.call(document.querySelectorAll('[data-checkout]'),function(a){
    var k=a.getAttribute('data-checkout'),url=(links[k]||'').trim();
    if(/^https:\/\//.test(url)){
      a.href=url;
    }else if(cfg.email){
      a.href='mailto:'+cfg.email+'?subject='+encodeURIComponent('Richiesta pacchetto '+(nomi[k]||k));
    }
  });
  /* Planner budget */
  var form=document.getElementById('iis-planner');
  if(form){
    var fmt=new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR',maximumFractionDigits:0});
    var sum=function(g){return Array.prototype.reduce.call(form.querySelectorAll('[data-group="'+g+'"]'),function(t,el){var v=parseFloat(el.value);return t+(Number.isFinite(v)&&v>0?v:0)},0)};
    var out=function(id,v){document.getElementById(id).textContent=fmt.format(v)};
    var calc=function(){
      var m=sum('month'),i=sum('initial'),s=sum('salary');
      out('r-month',m);out('r-initial',i);out('r-total',m+i);
      var row=document.getElementById('r-saving-row');
      row.hidden=!(s>0);
      if(s>0)out('r-saving',s-m);
    };
    calc();
    form.addEventListener('input',calc);
    form.addEventListener('reset',function(){setTimeout(calc,0)});
  }

  /* Chiudi il menu mobile dopo un click */
  var menu=document.querySelector('.iis-menu');
  if(menu){menu.addEventListener('click',function(e){if(e.target.tagName==='A')menu.removeAttribute('open')})}

  /* Barra CTA mobile */
  var bar=document.getElementById('iis-stickybar');
  var hero=document.getElementById('top');
  var pricing=document.getElementById('pacchetti');
  if(bar&&hero&&pricing&&'IntersectionObserver' in window){
    var heroOut=false,pricingIn=false,finalIn=false;
    var finalCta=document.getElementById('contatti');
    var update=function(){
      var show=heroOut&&!pricingIn&&!finalIn;
      bar.classList.toggle('is-visible',show);
      bar.setAttribute('aria-hidden',show?'false':'true');
      bar.querySelector('a').tabIndex=show?0:-1;
    };
    new IntersectionObserver(function(e){heroOut=!e[0].isIntersecting;update()}).observe(hero);
    new IntersectionObserver(function(e){pricingIn=e[0].isIntersecting;update()},{threshold:.15}).observe(pricing);
    if(finalCta)new IntersectionObserver(function(e){finalIn=e[0].isIntersecting||e[0].boundingClientRect.top<0;update()}).observe(finalCta);
  }

  /* ===== Effetti di scorrimento ===== */
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var prog=document.getElementById('iis-progress');
  var header=document.querySelector('.iis-header');
  var par=reduce?[]:Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  var route=document.querySelector('.iis-route-wrap');
  var fill=route&&route.querySelector('.iis-route__fill');
  var stops=route?Array.prototype.slice.call(route.querySelectorAll('.iis-route li')):[];
  var train=route&&route.querySelector('.iis-route__train');
  var track=route&&route.querySelector('.iis-route__track');
  var ticking=false;

  function frame(){
    ticking=false;
    var y=window.pageYOffset,vh=window.innerHeight;
    var max=document.documentElement.scrollHeight-vh;
    if(prog)prog.style.transform='scaleX('+(max>0?Math.min(y/max,1):0)+')';
    if(header)header.classList.toggle('is-scrolled',y>8);

    par.forEach(function(el){
      var box=(el.ownerSVGElement||el.parentElement).getBoundingClientRect();
      if(box.bottom<-200||box.top>vh+200)return;
      var off=(box.top+box.height/2-vh/2)*(parseFloat(el.getAttribute('data-parallax'))||0);
      var scale=el.getAttribute('data-scale');
      el.style.transform='translate3d(0,'+off.toFixed(1)+'px,0)'+(scale?' scale('+scale+')':'');
    });

    if(route&&fill){
      var r=route.getBoundingClientRect();
      var p=Math.max(0,Math.min(1,(vh*0.6-r.top)/r.height));
      fill.style.transform='scaleY('+p+')';
      stops.forEach(function(li){li.classList.toggle('is-done',li.offsetTop+10<=p*route.offsetHeight)});
      if(train&&track){train.style.transform='translate3d(0,'+(track.offsetTop+p*track.offsetHeight-20).toFixed(1)+'px,0)';}
    }
  }
  window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(frame)}},{passive:true});
  window.addEventListener('resize',frame);
  frame();

  /* Comparsa progressiva degli elementi */
  if(!reduce&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}});
    },{rootMargin:'0px 0px -8% 0px'});
    [
      ['.iis-section .iis-head',0],['.iis-topic',0],['.iis-plan',1],['.iis-assure__item',0],
      ['.iis-step',0],['.iis-route li',0],['.iis-band__content',0],['.iis-planner > *',0],
      ['.iis-about > *',0],['.iis-post',0],['.iis-faq details',0],['.iis-flip',0],['.iis-final',0],['.iis-contact',0]
    ].forEach(function(g){
      Array.prototype.forEach.call(document.querySelectorAll(g[0]),function(el,i){
        el.classList.add('iis-reveal');
        if(g[1])el.classList.add('iis-reveal--fade');
        el.style.setProperty('--d',((i%3)*0.1)+'s');
        io.observe(el);
      });
    });
  }

  /* Copertine 3D */
  var covers=document.querySelector('.iis-covers');
  var stage=covers&&covers.querySelector('.iis-covers__stage');
  if(stage&&!reduce&&window.matchMedia('(hover:hover)').matches){
    covers.addEventListener('pointermove',function(e){
      var r=covers.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
      stage.style.setProperty('--ry',(x*16).toFixed(2)+'deg');
      stage.style.setProperty('--rx',(-y*10).toFixed(2)+'deg');
    });
    covers.addEventListener('pointerleave',function(){
      stage.style.setProperty('--rx','0deg');stage.style.setProperty('--ry','0deg');
    });
  }

  /* Luce che segue il puntatore sulle card dei pacchetti */
  Array.prototype.forEach.call(document.querySelectorAll('.iis-plan'),function(card){
    card.addEventListener('pointermove',function(e){
      var r=card.getBoundingClientRect();
      card.style.setProperty('--mx',(e.clientX-r.left)+'px');
      card.style.setProperty('--my',(e.clientY-r.top)+'px');
    });
  });

  /* Carte "Lo sapevi?" */
  Array.prototype.forEach.call(document.querySelectorAll('.iis-flip'),function(b){
    b.addEventListener('click',function(){var flipped=b.getAttribute('aria-pressed')!=='true';b.setAttribute('aria-pressed',String(flipped));b.querySelector('.iis-flip__front').setAttribute('aria-hidden',String(flipped));b.querySelector('.iis-flip__back').setAttribute('aria-hidden',String(!flipped))});
  });

  /* Quiz pacchetto */
  var finder=document.getElementById('iis-finder');
  if(finder){
    var outText=document.getElementById('iis-finder-out');
    var go=document.getElementById('iis-finder-go');
    var names={partenza:'Partenza',lavoro:'Lavoro',completo:'Trasferimento Completo'};
    var why={
      partenza:'ti serve capire permessi, documenti e priorità prima di decidere.',
      lavoro:'la tua priorità è un CV e una candidatura in formato svizzero.',
      completo:'devi coordinare lavoro, casa, cassa malati e, se serve, scuola dei figli.'
    };
    finder.addEventListener('change',function(){
      var f=finder.querySelector('[name=fase]:checked'),fam=finder.querySelector('[name=famiglia]:checked');
      if(!f||!fam)return;
      var pick=f.value==='valuto'?'partenza':(f.value==='lavoro'&&fam.value==='no'?'lavoro':'completo');
      outText.innerHTML='Ti consigliamo <strong>'+names[pick]+'</strong>: '+why[pick];
      go.hidden=false;
      go.href='#pkg-'+pick;
      go.textContent='Vai a '+names[pick];
      Array.prototype.forEach.call(document.querySelectorAll('.iis-plan'),function(c){
        c.classList.toggle('is-match',c.getAttribute('data-plan')===pick);
      });
    });
  }
})();

(function(){document.querySelectorAll('[data-plan-request]').forEach(function(a){a.addEventListener('click',function(){var s=document.getElementById('interesse');if(s)s.value=a.dataset.package;});});})();
